import { selector, selectorFamily, useRecoilValue } from 'recoil';
import { DisputeService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { AdjustmentDisputeReason, DisputeReason, MarDisputeReason } from 'types';

export const disputeReasons = selector<DisputeReason[]>({
    key: 'disputeReasons',
    get: async ({ get }) => {
        get(refreshState('disputeReasons'));
        if (get(isAuthenticated)) {
            const service = new DisputeService();
            return await service.getDisputeReasons();
        }
        return [];
    }
});

export const adjustmentDisputeReasons = selector<AdjustmentDisputeReason[]>({
    key: 'adjustmentDisputeReasons',
    get: async ({ get }) => {
        get(refreshState('adjustmentDisputeReasons'));
        if (get(isAuthenticated)) {
            const service = new DisputeService();
            return await service.getAdjustmentDisputeReasons();
        }
        return [];
    }
});

export const marDisputeReasons = selector<MarDisputeReason[]>({
    key: 'marDisputeReasons',
    get: async ({ get }) => {
        get(refreshState('marDisputeReasons'));
        if (get(isAuthenticated)) {
            const service = new DisputeService();
            return await service.getMarDisputeReasons();
        }
        return [];
    }
});

export const disputeReason = selectorFamily<DisputeReason | undefined, number>({
    key: 'disputeReason',
    get: (reasonId) =>
        ({ get }) => {
            const reasons = get(disputeReasons);
            return reasons.find(({ disputeReasonId }) => disputeReasonId === reasonId);
        }
});

export const useDisputeReason = (disputeReasonId: number) => useRecoilValue(disputeReason(disputeReasonId));
export const useDisputeReasons = () => useRecoilValue(disputeReasons);
export const useAdjustmentDisputeReasons = () => useRecoilValue(adjustmentDisputeReasons);
export const useMarDisputeReasons = () => useRecoilValue(marDisputeReasons);
export const useRefreshDisputeReasons = () => useSetRefreshState(disputeReasons);